/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { FeatureLike } from "ol/Feature";
import { Vector as VectorLayer } from "ol/layer";
import { Cluster, Vector as VectorSource } from "ol/source";
import { Fill, Stroke, Style, Text } from "ol/style";
import CircleStyle from "ol/style/Circle";
import { LayerDefaults, LayerTitle } from "../types/layers";
import { AtoNMapItem } from "../types/mapItems";
import { generateAtoNStyle } from "./generateAtoNStyle";
import { readMapSettings } from "./localMapSettings";

interface Return {
  source: VectorSource;
  layer: VectorLayer;
}

function createAtoNLayer(): Return {
  const source = new VectorSource();
  const title = LayerTitle.AtoNs;

  const clusterStyleCache: {
    [key: string]: Style;
  } = {};

  const layer = new VectorLayer({
    source: new Cluster({
      distance: 20,
      source,
    }),
    zIndex:
      readMapSettings("layers", title)?.zIndex ?? LayerDefaults[title].zIndex,
    visible:
      readMapSettings("layers", title)?.visible ?? LayerDefaults[title].visible,
    style: (feature) => {
      const size: number = feature.get("features")?.length;
      const clustered = size > 1;
      let clusterStyle: Style;
      const faultsInCluster = (feature.get("features") as FeatureLike[])?.some(
        (a) => (a.getProperties() as AtoNMapItem)?.activeFaultCount > 0,
      );
      const clusterKey = `${size}-${faultsInCluster}`;
      if (clusterStyleCache[clusterKey]) {
        clusterStyle = clusterStyleCache[clusterKey];
      } else {
        clusterStyle = new Style({
          image: new CircleStyle({
            radius: 10,
            fill: new Fill({
              color: faultsInCluster ? "#C0392B" : "#E07C24",
            }),
            stroke: new Stroke({
              color: "#000",
              width: 1,
            }),
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff",
            }),
            font: "16px Roboto",
            stroke: new Stroke({
              color: "#000",
              width: 2,
            }),
          }),
        });
        clusterStyleCache[clusterKey] = clusterStyle;
      }
      const style = clustered
        ? clusterStyle
        : generateAtoNStyle(feature.get("features")?.[0]);
      return style;
    },
  });
  layer.set("title", title);
  return { source, layer };
}

export default createAtoNLayer;
